/* global window */
import ponyfill from './ponyfill.js';

var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = ponyfill(root);
export default result;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/symbol-observable/es/index.js
// module id = 542
// module chunks = 2 3 4 5 6 8 9 10 11 13